<template>
  <section>
    <b-row class="flex-wrap">
      <b-col class="d-flex px-50" lg="4">
        <all-time-top-gainers
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col class="d-flex px-50" lg="4">
        <safest-traders-by-drawdown
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col class="d-flex px-50" lg="2">
        <total-win-to-loss-ratio
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col class="d-flex px-50" lg="2">
        <total-sell-to-buy-ratio
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col class="px-0" lg="5">
        <b-col class="d-flex px-50" lg="12">
          <competitions-summary
            class="w-100"
            :loading="loading"
            :analytics="analytics"
          />
        </b-col>
        <b-col class="d-flex px-50" lg="12">
          <most-traded-symbols
            class="w-100"
            :loading="loading"
            :analytics="analytics"
          />
        </b-col>
      </b-col>
      <!-- <b-col class="d-flex px-50" lg="7"> </b-col> -->
      <!-- <b-col class="d-flex px-50" lg="7">
        <number-of-unique-participants   class="w-100" />
      </b-col> -->
      <b-col class="d-flex px-50 flex-wrap" lg="7">
        <b-col class=" px-0" cols="12">
          <total-profits-made-by-participants class="w-100" />
        </b-col>
        <!-- <b-col class="d-flex px-0" cols="12">
          <audience-growth-over-time :loading="loading" class="w-100" />
        </b-col> -->
      </b-col>
    </b-row>

    <!-- <advanced-analytics /> -->
  </section>
</template>

<script>
import { BRow, BCol, VBTooltip, BButton } from "bootstrap-vue";
import AllTimeTopGainers from "./AllTimeTopGainers.vue";
import SafestTradersByDrawdown from "./SafestTradersByDrawdown.vue";
import MostTradedSymbols from "./MostTradedSymbols.vue";
import CompetitionsSummary from "./CompetitionsSummary.vue";
import TotalWinToLossRatio from "./TotalWinToLossRatio.vue";
import TotalSellToBuyRatio from "./TotalSellToBuyRatio.vue";
// import NumberOfUniqueParticipants from "./NumberOfUniqueParticipants.vue";
import TotalProfitsMadeByParticipants from "./TotalProfitsMadeByParticipants.vue";
// import AudienceGrowthOverTime from "./AudienceGrowthOverTime.vue";
import AdvancedAnalytics from "./advanced-analytics/AdvancedAnalytics.vue";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    AllTimeTopGainers,
    SafestTradersByDrawdown,
    MostTradedSymbols,
    CompetitionsSummary,
    TotalWinToLossRatio,
    TotalSellToBuyRatio,
    // NumberOfUniqueParticipants,
    TotalProfitsMadeByParticipants,
    // AudienceGrowthOverTime,
    AdvancedAnalytics,
  },

  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      analytics: {},
      loading: false,
    };
  },
  methods: {
    async getAnalytics() {
      try {
        const { data } = await this.$http.get(`/panel/competitions/analytics`);
        this.analytics = data;
      } catch (err) {}
    },
  },
  async created() {
    this.loading = true;
    await this.getAnalytics();
    this.loading = false;
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
